import DispatchConstants from '../constants/DispatchConstants';

import type { ApiListItemType } from '../reducers/devTool';

const DevToolActions = {
  addDevToolApiList(data: ApiListItemType) {
    return (dispatch: (arg: { type: string; payload: ApiListItemType }) => void, getState: () => unknown) => {
      const {
        // @ts-expect-error
        app: {
          cookieEnabledServices: { ZRM_DEVTOOLS_ENABLED },
        },
      } = getState();

      if (!ZRM_DEVTOOLS_ENABLED) {
        return;
      }

      return dispatch({
        type: DispatchConstants.ADD_DEV_TOOL_API_LIST,
        payload: data,
      });
    };
  },

  updateDevTool(data: Record<string, unknown>) {
    return (dispatch: (arg: { type: string; payload: Record<string, unknown> }) => void, getState: () => unknown) => {
      const {
        // @ts-expect-error
        app: {
          cookieEnabledServices: { ZRM_DEVTOOLS_ENABLED },
        },
      } = getState();

      if (!ZRM_DEVTOOLS_ENABLED) {
        return;
      }

      return dispatch({
        type: DispatchConstants.UPDATE_DEV_TOOL,
        payload: data,
      });
    };
  },
};

export default DevToolActions;
